import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      ...theme.eatclub.typography.cancelTitle,
      maxWidth: '620px',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '34px',
      lineHeight: '1.4',
    },
    pageContent: {
      fontSize: '18px',
      maxWidth: '600px',
    },
    projectionItems: {
      paddingTop: '40px',
      paddingBottom: '60px',
    },
    projectionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 2px',
      lineHeight: '26px',
    },
    valuePoints: {
      // display: 'flex',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      // padding: '20px',
      gap: '24px',
    },
    pillar: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    pillarIcon: {
      width: '32px',
      height: '32px',
    },
  }),
  { name: 'CancelLandingPage' },
);

export default useStyles;
